module.exports = __webpack_public_path__ + "static/media/icon_pos_pago_estacionamento.186f34bc.svg";